import React from "react";
import Carousel from "@/bit/components/components.carousel";
import Text, {
  TEXT_ALIGN,
  TEXT_FONT_WEIGHT,
  TEXT_HEADING_LEVEL,
  TEXT_KIND,
  TEXT_SIZE,
  TEXT_COLOR,
} from "@/bit/components/components.text";
import style from "./style";
import Slide from "./slide";

const FeaturedCarousel = ({
  hash = "",
  title,
  carouselItems,
  taggingInfo,
  query,
}) => {
  return (
    <>
      <div
        className="col-xs-12 col-sm-6 col-md-9 featured-carousel"
        data-cy="FeaturedSection Carousel"
      >
        {title && (
          <Text
            text={title}
            kind={TEXT_KIND.HEADING}
            level={TEXT_HEADING_LEVEL.H2}
            align={TEXT_ALIGN.LEFT}
            size={TEXT_SIZE.T6}
            fontType={TEXT_FONT_WEIGHT.BOLD}
            color={TEXT_COLOR.BLUE_DARK}
            className="carousel-title"
          />
        )}
        {carouselItems && Array.isArray(carouselItems) && (
          <Carousel slideSeparation={8}>
            {carouselItems.map((item, index) => (
              <Slide
                hash={hash}
                img={{ src: item.img, alt: item.altSEO, title: item.titleSEO }}
                title={{ text: item.title }}
                description={{ text: item.description }}
                link={{ href: item.href }}
                key={`${item.title}-${index}`}
                taggingInfo={taggingInfo}
              />
            ))}
          </Carousel>
        )}
      </div>
      <style jsx>{style}</style>
    </>
  );
};

export default FeaturedCarousel;
